import {BehaviorSubject} from 'rxjs';
import {map} from 'rxjs/operators';
import {currencies$, currenciesWithChain$} from '@/streams/config/currency';
import {contracts$} from '@/streams/config/contract';

export const coinOptions$ = new BehaviorSubject([]);
export const coinOptionsWithChain$ = new BehaviorSubject([]);
export const contractOptions$ = new BehaviorSubject([]);
export const fundingHistoryOptions$ = new BehaviorSubject([]);
export const indexPriceOptions$ = new BehaviorSubject([]);
export const markPriceOptions$ = new BehaviorSubject([]);

currencies$.pipe(map(convertCoinOptions)).subscribe((o) => coinOptions$.next(o));
currenciesWithChain$.pipe(map(convertCoinOptions)).subscribe((o) => coinOptionsWithChain$.next(o));
contracts$.pipe(map(convertContractOptions)).subscribe((o) => contractOptions$.next(o));
contracts$.pipe(map(convertFundingHistoryOptions)).subscribe((o) => fundingHistoryOptions$.next(o));
contracts$.pipe(map(convertIndexPriceOptions)).subscribe((o) => indexPriceOptions$.next(o));
contracts$.pipe(map(convertMarkPriceOptions)).subscribe((o) => markPriceOptions$.next(o));

function convertCoinOptions(currencies) {
  return currencies
    .filter((item) => !!item.inAssetsDisplay)
    .map((item) => ({
      text: item.displayCurrency,
      value: item.currency,
      name: item.name,
      currencyCode: item.code,
    }));
}

function convertContractOptions(items) {
  return items
    .filter((item) => item.status === 'Listed')
    .map((item) => {
      const {symbol, symbolV2, settleCurrency, settleCurrencyDisplay, baseCurrency, originType} = item;
      return {
        text: symbolV2,
        value: symbol,
        settleCurrency,
        settleCurrencyDisplay,
        baseCurrency,
        originType,
      };
    });
}

function convertFundingHistoryOptions(items) {
  return items
    .filter((item) => item.status === 'Listed')
    .map((item) => {
      const {symbolV2, fundingRate8hSymbol, settleCurrency, settleCurrencyDisplay, baseCurrency, originType} = item;
      return {
        text: symbolV2,
        value: fundingRate8hSymbol,
        settleCurrency,
        settleCurrencyDisplay,
        baseCurrency,
        originType,
      };
    });
}

function convertIndexPriceOptions(items) {
  return items
    .filter((item) => item.status === 'Listed')
    .map((item) => {
      const {indexSymbol, settleCurrency, settleCurrencyDisplay, baseCurrency, originType} = item;
      return {
        text: '.' + baseCurrency,
        value: indexSymbol,
        settleCurrency,
        settleCurrencyDisplay,
        baseCurrency,
        originType,
      };
    });
}

function convertMarkPriceOptions(items) {
  return items
    .filter((item) => item.status === 'Listed')
    .map((item) => {
      const {markSymbol, settleCurrency, baseCurrency, settleCurrencyDisplay, originType} = item;
      return {
        text: '.M' + baseCurrency,
        value: markSymbol,
        settleCurrency,
        settleCurrencyDisplay,
        baseCurrency,
        originType,
      };
    });
}
